import * as React from 'react';
import { ThemeProvider } from 'styled-components';
import { InputIconWrapper, InputWrapper as StyledInputWrapper, LabelWrapper, textInputThemes, ErrorMessage, } from '../../styles/sharedInputStyles';
import InputTooltip from '../InputTooltip';
import LeadIcons from '../LeadIcons';
import { Label } from '../Text';
import { Warning } from '../../icons/Warning';
export const InputWrapper = React.memo(({ label, trailingIcon, leadingIcon, required, value, disabled, tooltip, tooltipPosition = 'top-right', tooltipButtonTitle = 'Toggle tooltip', state = 'default', errorMessage = '', children, }) => {
    const themeVars = textInputThemes[state];
    const themeStateVars = {
        hasValue: !!value,
        hasTrailingIcon: !!trailingIcon,
        hasLeadingIcon: !!leadingIcon,
    };
    const iconColor = disabled
        ? themeVars.iconColor
        : themeStateVars.hasValue
            ? themeVars.placeholderNotShownIconColor
            : themeVars.iconColor;
    return (React.createElement(ThemeProvider, { theme: { vars: themeVars, state: themeStateVars } },
        React.createElement(LabelWrapper, null,
            React.createElement(Label, { label: label, required: required, size: "medium" },
                React.createElement(StyledInputWrapper, null,
                    React.createElement(InputIconWrapper, null,
                        React.createElement(LeadIcons, { iconColor: iconColor, leadingIcon: leadingIcon, trailingIcon: trailingIcon }, children)),
                    tooltip && React.createElement(InputTooltip, { text: tooltip, position: tooltipPosition, buttonTitle: tooltipButtonTitle }))),
            errorMessage && state === 'error' ? (React.createElement(ErrorMessage, null,
                React.createElement(Warning, null),
                errorMessage)) : null)));
});
export default InputWrapper;
//# sourceMappingURL=InputWrapper.js.map